export enum Severity {
  Info,
  Warning,
  Error,
}
